/**
 * Theme overrides for the Apache-2.0 replacement of `@/ee/whitelabeling`
 * (Omnyqra/sim#14).
 *
 * Emits a `:root` block only for brand colors set in the environment, so an
 * unbranded deployment keeps the stylesheet's own tokens. The variables are
 * the ones whose stylesheet values equal the brand defaults
 * (`lib/branding/defaults.ts`, `app/_styles/omnyqra.css`). Omnyqra sets none
 * of these variables; its look is fixed in the stylesheet. See `SPEC.md`
 * (WL-003).
 */
import { HEX_COLOR_REGEX } from '@/lib/branding'
import { getEnv } from '@/lib/core/config/env'

const THEME_VARIABLES = [
  ['NEXT_PUBLIC_BRAND_PRIMARY_COLOR', ['--brand-accent']],
  ['NEXT_PUBLIC_BRAND_PRIMARY_HOVER_COLOR', ['--brand-accent-hover', '--brand-hover']],
  ['NEXT_PUBLIC_BRAND_ACCENT_COLOR', ['--brand-secondary']],
] as const

export function generateThemeCSS(): string {
  const declarations: string[] = []
  for (const [variable, properties] of THEME_VARIABLES) {
    const color = getEnv(variable)
    /** The env schema validates these too; the check keeps arbitrary text out of the `<style>`. */
    if (!color || !HEX_COLOR_REGEX.test(color)) continue
    for (const property of properties) declarations.push(`${property}: ${color};`)
  }
  return declarations.length > 0 ? `:root { ${declarations.join(' ')} }` : ''
}
